import { useContext } from 'react';

import { LocationContext } from './location-context';

function useLocation() {
  return useContext(LocationContext);
}

export { useLocation };